<template>
  <div id="index" class="index">
    <div class="billing-tabs">
      <el-tabs v-model="selectNumber">
        <el-tab-pane label="账单" name="one" />
        <el-tab-pane label="银行明细" name="two" />

      </el-tabs>
      <invoice-table v-if="selectNumber == 'one'" class="margin-top_16" />
      <bank-detail v-if="selectNumber == 'two'" class="margin-top_16" />

    </div>
  </div>
</template>

<script>
import bankDetail from './bankDetail.vue'
import invoiceTable from './invoiceTable.vue'
export default {
  components: {
    invoiceTable,
    bankDetail
  },
  data() {
    return {
      selectNumber: 'one'
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
}
</script>

<style scoped lang="scss">
.billing-tabs {
  padding: 0 4px;
  height: 56px;
  background: #ffffff;
  border-radius: 8px;

  & ::v-deep .el-tabs {
    .el-tabs__header {
      margin: 0;
    }

    .el-tabs__nav-wrap::after {
      background-color: transparent;
    }

    .el-tabs__item {
      padding: 18px 16px;
      height: 56px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 13px;
      color: #333333;
      line-height: 18px;
      text-align: center;
      font-style: normal;
      box-sizing: border-box;
    }

    .el-tabs__item.is-active {
      font-family: PingFangSC, PingFang SC;
      font-weight: 550;
      font-size: 13px;
      color: #3370ff;
      line-height: 18px;
      text-align: center;
      font-style: normal;
    }

    .el-tabs__active-bar {
      background-color: #3370ff;
    }
  }
}
</style>
